import { FC } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

type Props = {
  title: string;
  editMode?: boolean;
  setEditMode?: (editMode: boolean) => void;
  onSave?: () => void;
  children: React.ReactNode;
  button?: React.ReactNode;
  showButton?: boolean;
};

export const SettingsCard: FC<Props> = ({
  title,
  children,
  editMode,
  setEditMode,
  onSave,
  button,
  showButton = true
}) => {
  return (
    <div className="w-full rounded-lg border border-alpha-100 bg-background-1000 p-6 lg:max-w-[800px]">
      <div className="mb-6 flex items-center justify-between gap-2">
        <h2 className="text-base font-bold text-content-1000">{title}</h2>
        {!showButton ? null : button ? (
          button
        ) : editMode ? (
          <Button
            size={ButtonSize.SM}
            variant={ButtonVariant.PRIMARY}
            onClick={() => {
              if (onSave) onSave();
              setEditMode?.(false);
            }}
          >
            Save
          </Button>
        ) : (
          <Button size={ButtonSize.SM} onClick={() => setEditMode?.(true)}>
            Edit
          </Button>
        )}
      </div>
      {children}
    </div>
  );
};
